/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingplacetitle2Inputs */

const en_onboardingplacetitle2 = /** @type {(inputs: Onboardingplacetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue or place`)
};

const de_onboardingplacetitle2 = /** @type {(inputs: Onboardingplacetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokal oder Ort`)
};

/**
* | output |
* | --- |
* | "Venue or place" |
*
* @param {Onboardingplacetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingplacetitle2 = /** @type {((inputs?: Onboardingplacetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingplacetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingplacetitle2(inputs)
	return de_onboardingplacetitle2(inputs)
});
export { onboardingplacetitle2 as "onboardingPlaceTitle" }